import React, {useMemo} from "react";
import {DetailKvExpandableList} from "./DetailKvExpandableList";
import {getKvListLabel, KV_LIST_TYPES} from "./detailKvListLabels";

/**
 * KV 보기 모드 — 다건 목록 공통 컴포넌트
 * listType: asset | user | contract
 */
export function DetailKvListValue({
    items,
    listType = KV_LIST_TYPES.asset,
    nameKey,
}) {
    const getLabel = useMemo(() => {
        if (nameKey) {
            return (item) => item?.[nameKey] ?? item?.assetName ?? item?.title ?? "";
        }
        return (item) => getKvListLabel(item, listType);
    }, [listType, nameKey]);

    return <DetailKvExpandableList items={items} getLabel={getLabel} listType={listType} />;
}
